import React, {Component}   from 'react';
import PropTypes            from 'prop-types';

let FaInfo = require('react-icons/lib/fa/info');
let FaTimes = require('react-icons/lib/fa/close');

class HelpIcon extends Component {
    constructor(props) {
        super(props);
        this.state = {
            active: false
        };
    }

    handleClick() {
        this.props.onClick();
        this.setState({
            active: (this.state.active) ? false: true
        });
    }

    render() {
        return (
            <div onClick={this.handleClick.bind(this)} className={this.state.active === true ? "help-icon active" : "help-icon"}>
                {this.state.active === true ?
                    <FaTimes className="active-icon" />
                :
                    <FaInfo className="inactive-icon" />
                }
            </div>
        );
    }
}

HelpIcon.propTypes = {
    onClick: PropTypes.func
};

export default HelpIcon;


// WEBPACK FOOTER //
// ./src/components/Fragments/HelpIcon.js